import "./BtnWhatsapp.css";
import Icon from "../icon/Icon";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const BtnWhatsapp = () => {
  const goToWhatsApp = () => {
    const phoneNumber = "5493416697243";
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, "_blank");
  };
  return (
    <div className="btn-whatsapp">
      <button className="icon-whatsapp" onClick={goToWhatsApp}>
        <Icon icon={faWhatsapp} />
      </button>
    </div>
  );
};

export default BtnWhatsapp;
